<form
  class="bk-panel set-panel"
  [formGroup]="changePasswordForm"
  (ngSubmit)="handleSubmit()"
  novalidate
  aria-labelledby="pw-title"
>
  <header class="set-panel__head">
    <div class="set-panel__intro">
      <h2 class="set-panel__title" id="pw-title">Password</h2>
      <p class="set-panel__sub">Change the password you sign in with. You stay signed in on this device.</p>
    </div>
  </header>

  <!-- Hidden username so password managers file the new password under the right account -->
  <input
    type="text"
    class="bk-sr-only"
    name="username"
    autocomplete="username"
    tabindex="-1"
    aria-hidden="true"
    [value]="userProfileData?.email || ''"
    readonly
  />

  <div class="set-grid">
    <input-field class="is-wide pw__current" label="Current password" [errorMessage]="currentPasswordErrorMsg">
      <div class="bk-field__wrap">
        <input
          class="input-style pw__input"
          [type]="showCurrentPassword ? 'text' : 'password'"
          autocomplete="current-password"
          placeholder="The password you use now"
          formControlName="currentPassword"
        />
        <button
          type="button"
          class="bk-field__reveal"
          [attr.aria-label]="showCurrentPassword ? 'Hide current password' : 'Show current password'"
          [attr.aria-pressed]="showCurrentPassword"
          (click)="toggleCurrentPasswordVisibility()"
        >
          <span class="bk-sym" aria-hidden="true">{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
    </input-field>

    <input-field label="New password" [errorMessage]="newPasswordErrorMsg">
      <div class="bk-field__wrap">
        <input
          class="input-style pw__input"
          [type]="showNewPassword ? 'text' : 'password'"
          autocomplete="new-password"
          placeholder="At least 8 characters"
          formControlName="newPassword"
          aria-describedby="pw-rules"
        />
        <button
          type="button"
          class="bk-field__reveal"
          [attr.aria-label]="showNewPassword ? 'Hide new password' : 'Show new password'"
          [attr.aria-pressed]="showNewPassword"
          (click)="toggleNewPasswordVisibility()"
        >
          <span class="bk-sym" aria-hidden="true">{{ showNewPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
    </input-field>

    <input-field label="Confirm new password" [errorMessage]="confirmPasswordErrorMsg">
      <div class="bk-field__wrap">
        <input
          class="input-style pw__input"
          [type]="showConfirmPassword ? 'text' : 'password'"
          autocomplete="new-password"
          placeholder="Type it again"
          formControlName="confirmPassword"
        />
        <button
          type="button"
          class="bk-field__reveal"
          [attr.aria-label]="showConfirmPassword ? 'Hide confirmed password' : 'Show confirmed password'"
          [attr.aria-pressed]="showConfirmPassword"
          (click)="toggleConfirmPasswordVisibility()"
        >
          <span class="bk-sym" aria-hidden="true">{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</span>
        </button>
      </div>
    </input-field>

    <!-- What the new password needs, ticked off as it is typed -->
    <ul class="pw__rules is-wide" id="pw-rules" role="list" aria-label="Password rules">
      @for (rule of rules; track rule.label) {
        <li class="pw__rule" [class.is-met]="rule.met">
          <span class="bk-sym pw__mark" aria-hidden="true">{{ rule.met ? 'check_circle' : 'radio_button_unchecked' }}</span>
          <span>{{ rule.label }}</span>
          <span class="bk-sr-only">{{ rule.met ? '(done)' : '(not yet)' }}</span>
        </li>
      }
    </ul>
  </div>

  @if (showFeedback && feedbackType !== 'success') {
    <p class="set-alert pw__alert" role="alert">
      <span class="bk-sym" aria-hidden="true">error</span>
      <span>{{ feedbackMessage }}</span>
    </p>
  }

  <footer class="set-foot">
    <span class="set-foot__note" aria-live="polite">{{ rulesMet }} of {{ rules.length }} rules met</span>
    <customizable-button
      title="Change password"
      className="w-full"
      type="submit"
      [loading]="isUpdatingPassword"
      [disabled]="isUpdatingPassword"
    />
  </footer>
</form>
